import React, { useEffect, useState } from 'react';
import { AxiosError, AxiosResponse } from 'axios';

import { mainMenuTypes, IMenuItem } from '@app/components/Sidebar/menuObject';
import { getMenuItemById } from '@app/helpers';
import { useSetPage, useTypedTranslation } from '@app/hooks';
import { Link, Table, TableBody, TableCell, TableHead, TableRow } from '@material-ui/core';
import { basicService } from '@app/services';
import { darkwebService } from '@app/services';
import Icon from '@app/components/Icon';
import { IGlobalState, IShellConfig } from '@app/models';
import { useSelector } from 'react-redux';

const IntegrationManagerPage = () => {
    const { translation } = useTypedTranslation();
    const shellConfig: IShellConfig = useSelector((state: IGlobalState) => state.basic.shellConfig);
    const item: IMenuItem | undefined = getMenuItemById(mainMenuTypes.IntegrationManager);
    const [isDarkWebActive, setIsDarkWebActive] = useState(false);

    const dwidEnabled = shellConfig.intercom.dwidEnabled;;

    const handleRedirectToDarkweb = () => {
        if (isDarkWebActive) {
            basicService.redirect('/integrations/darkweb');
        }
    };

    const handleRedirectToBullphish = () => {
        basicService.redirect('/integrations/bullphish');
    };

    const handleSuccess = (res: AxiosResponse) => {
        setIsDarkWebActive(res.data.darkWeb);
    };

    const handleError = (error: AxiosError<any>) => {
        console.log('error =', error);
    };

    useEffect(() => {
        darkwebService.getIntegrations(handleError, handleSuccess);
    }, []);

    useSetPage(null, item);

    return (
    <>
        <div className='integration-manager'>
            <div className='content'>
                <h1 className='header--h1'>{translation('INTEGRATION_MANAGER_TITLE')}</h1>
                <Table style={{ tableLayout: 'fixed' }}>
                    <TableHead>
                        <TableRow>
                            <TableCell>
                                <strong>{translation('INTEGRATION_MANAGER_TABLE_COL-1')}</strong>
                            </TableCell>
                            <TableCell style={{ width: 185 }}>
                                <strong>{translation('INTEGRATION_MANAGER_TABLE_COL-2')}</strong>
                            </TableCell>
                        </TableRow>
                    </TableHead>
                </Table>
                <Table style={{ tableLayout: 'fixed' }}>
                    <TableBody>
                        {dwidEnabled && (
                            <TableRow onClick={handleRedirectToDarkweb} className={`${isDarkWebActive && 'integration-manager__row-clickable'}`}>
                            <TableCell>
                                <div className='integration-manager__row'>
                                    <Icon icon='darkWebIdIco' className='integration-manager__icon' />
                                    <Link underline='none'>{translation('INTEGRATION_MANAGER_TABLE_DARK_WEB_ID')}</Link>{' '}
                                </div>
                            </TableCell>
                            <TableCell style={{ width: 185 }}>
                                {isDarkWebActive ? (
                                    <span className='integration-manager__status-active'>
                                        {translation('INTEGRATION_MANAGER_TABLE_STATUS_ACTIVE')}
                                    </span>
                                ) : (
                                    <span className='integration-manager__status-disabled'>
                                        {translation('INTEGRATION_MANAGER_TABLE_STATUS_INACTIVE')}
                                    </span>
                                )}
                            </TableCell>
                        </TableRow>
                        )}
                        <TableRow onClick={handleRedirectToBullphish} className='integration-manager__row-clickable'>
                            <TableCell>
                                <div className='integration-manager__row'>
                                    <Icon icon='bullphishIdIco' className='integration-manager__icon' />
                                    <Link underline='none'>{translation('INTEGRATION_MANAGER_TABLE_BULLPHISH_ID')}</Link>{' '}
                                </div>
                            </TableCell>
                            <TableCell style={{ width: 185 }}>
                            </TableCell>
                        </TableRow>
                    </TableBody>
                </Table>
            </div>
        </div>
    </>);
};

export default IntegrationManagerPage;
